export default class Career {
  constructor (dataCareer) {
    this.id = dataCareer.id
    this.seasonId = dataCareer.seasonId
    this.teamId = dataCareer.teamId
    this.personId = dataCareer.personId
    this.typeId = dataCareer.typeId
    this.positionId = dataCareer.positionId
    this.shirt = dataCareer.shirt
    this.start = dataCareer.end ? new Date(dataCareer.start) : null
    this.end = dataCareer.end ? new Date(dataCareer.end) : null
  }
}
